/**
 * @constant NOTIFICATIONS_TYPE
 * @type {{
 *  SUCCESS: string,
 *  ERROR: string,
 *  WARNING: string,
 *  INFO: string
 * }}
 */
export const NOTIFICATIONS_TYPE = {
    SUCCESS: 'success-notification',
    ERROR: 'error-notification',
    WARNING: 'warning-notification',
    INFO: 'info-notification',
};
